
 export const getHeaders = async () => {
    // Get browser locale/language
    const locale = navigator.language || navigator.userLanguage;

    // Determine device type
    const userAgent = navigator.userAgent;
    const platform = navigator.platform;
    let deviceType = 'Unknown';
    if (/android/i.test(userAgent)) {
        deviceType = 'Android';
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        deviceType = 'iOS';
    } else if (/Windows Phone/i.test(userAgent)) {
        deviceType = 'Windows Phone';
    } else if (/Win/i.test(platform)) {
        deviceType = 'Windows';
    } else if (/Mac/i.test(platform)) {
        deviceType = 'Mac';
    } else if (/Linux/i.test(platform)) {
        deviceType = 'Linux';
    }

    const nullLocation = {
        latitude: 0,
        longitude: 0
    }

    // Get location (latitude and longitude)
    const getLocation = () => {
        return new Promise((resolve, reject) => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        resolve({
                            latitude: position.coords.latitude,
                            longitude: position.coords.longitude
                        });
                    },
                    (error) => {
                        resolve({
                            nullLocation
                        })
                    }
                );
            } else {
                console.error('Geolocation is not supported by this browser.');
                resolve({
                    nullLocation
                })
            }
        });
    };

    const location = await getLocation();
    
    return {
        'Content-Type': 'application/json',
        // 'Origin': 'https://cors-test.codehappy.dev',
        // 'Access-Control-Request-Method': 'POST',
        // 'Access-Control-Request-Headers': 'Content-Type,Latitude,Longitude,Locale,Device-Type'
        // Uncomment the following lines if you want to include location and device type in headers
        // 'Latitude': location?.latitude,
        // 'Longitude': location?.longitude,
        // 'Accept-Language': locale,
        // 'Device-Type': deviceType
    };
};
